import "../node_modules/regenerator-runtime/runtime";
import {handleFirstJSError} from "../blink-sdk/utils/AnalyticsClient";

// TODO @branch still not the optimal place
window.onerror = handleFirstJSError;

import {UI} from "../stem-core/src/ui/UIBase";

window.UI = UI;

export * from "./State";
export * from "./InitIFrameApp";
